/**
 *  @class
 *  @function MixMatch
 */
class MixMatch {
  constructor(section) {
    if(!section) return;
    this.container = section.querySelector('#Mix-Match-Drawer');
    this.button = section.querySelectorAll('.mix-max-toggle');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          dispatchCustomEvent('mix-match-drawer:open');
        }
        return false;
      });
    });
  }
}

const mixMatches = Array.from(document.querySelectorAll('[data-mix-match]'));

mixMatches.forEach((mixMatch) => {
  if (mixMatch) {
    new MixMatch(mixMatch);
  }
});